export const LOGIN_PATH = '/login';
export const ANIMALS_PATH = '/';
export const CHANCE_3_CIFRAS_PATH = '/chance-3-cifras';
export const CHANCE_ZODIACAL_PATH = '/chance-zodiacal';
export const CHANCE_4_CIFRAS_PATH = '/chance-4-cifras';
export const TICKET_CANCEL_PATH = '/ticket-cancel';
export const TICKET_WINNER_PATH = '/ticket-winner';
export const CUSTOMER_PATH = '/customer';
export const CLOSE_WORKSHIFT_PATH = '/close-workshift';
